import React from 'react'
import { useHistory } from 'react-router-dom'
import { useIntl } from 'react-intl'

import {
  MessageBox,
  MESSAGE_BOX_VARIANT_HELP,
  Link,
  LINK_VARIANT_EXTRALIGHT
} from 'mailup-web-components'
import PropTypes from 'prop-types'

const LinkCheck = ({ idMessage }) => {
  const intl = useIntl()
  const history = useHistory()

  const redirectEmailCheckUp = () => {
    const route = `/messages/email/${idMessage}/checkup/linkcheck`
    history.push(route)
  }

  return (
    <>
      <MessageBox
        title={intl.formatMessage({
          id: 'Load.EmailCheckUp.LinkCheck'
        })}
        variant={MESSAGE_BOX_VARIANT_HELP}
      >
        {intl.formatMessage(
          {
            id: 'Load.EmailCheckUp.LinkCheckDescrIntl'
          },
          {
            link: content => (
              <Link
                variant={LINK_VARIANT_EXTRALIGHT}
                key={content}
                onClick={redirectEmailCheckUp}
              >
                {content}
              </Link>
            )
          }
        )}
      </MessageBox>
    </>
  )
}
LinkCheck.propTypes = {
  idMessage: PropTypes.number
}

export default LinkCheck
